import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { billingApi } from '../services/api';
import { Clock } from 'lucide-react';

export default function TrialBanner() {
  const [license, setLicense] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    billingApi.getLicense().then((res) => setLicense(res.data)).catch(() => {});
  }, []);

  if (!license || license.license_type !== 'trial' || license.days_remaining == null) return null;

  const urgent = license.days_remaining <= 2;

  return (
    <button
      onClick={() => navigate('/upgrade')}
      className="w-full flex items-center justify-center gap-2 py-2 text-[12.5px] font-semibold transition-colors"
      style={urgent
        ? { background: '#FBEEDA', color: '#9A5B0A' }
        : { background: '#E7ECFB', color: '#2A52C4' }}
      data-testid="trial-banner"
    >
      <Clock className="w-3.5 h-3.5" />
      {license.days_remaining === 0
        ? 'Il trial scade oggi'
        : `Trial: ${license.days_remaining} ${license.days_remaining === 1 ? 'giorno rimasto' : 'giorni rimasti'}`}
      <span className="underline underline-offset-2">Scegli un piano</span>
    </button>
  );
}
